export default "__VITE_ASSET__WUoLZ29___"